module.exports = class ProductsNewContainerCtrl
  constructor: (RESTService, ToastService, $state, FormDataSerializerService) ->
    'ngInject'
    @RESTService = RESTService
    @ToastService = ToastService
    @$state = $state
    @FormDataSerializerService = FormDataSerializerService

  $onInit: ->
    @product = {}

  createProduct: (product) ->
    @RESTService
      .one('admin/products')
      .withHttpConfig(transformRequest: angular.identity)
      .customPOST(@FormDataSerializerService(product), '', undefined, {'Content-Type': undefined})
      .then =>
        @ToastService.success('Product successfully created!')
        @$state.go('^.list')
      .catch (e) =>
        @ToastService.error(e.data.error)
